module.exports = __webpack_public_path__ + "static/media/34DSS10.84b39396.jpg";